import { ImportarAFD } from '@/templates/Integracoes/AFD/modal/Importar'
import React from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
import ExcluirAEJ from 'templates/Integracoes/AEJ/ExcluirRelatorio'
import GerarRelatorioAEJ from 'templates/Integracoes/AEJ/NovoRelatorio'
import { GerarAfdModal } from 'templates/Integracoes/AFD/modal/GerarAfd'
import ExportacaoTxt from 'templates/Integracoes/FolhaPagamento/modal/ExportacaoTxt'
import AdicionarRep from 'templates/Integracoes/REPs/components/modals/Adicionar'
import AssociarFuncionariosRep from 'templates/Integracoes/REPs/components/modals/AssociarFuncionarios'
import EditarRep from 'templates/Integracoes/REPs/components/modals/Editar'
import ExcluirRep from 'templates/Integracoes/REPs/components/modals/Excluir'
import AdicionarCredencial from 'templates/Integracoes/CredenciaisApi/modals/AdicionarPage'
import EditarCredencial from 'templates/Integracoes/CredenciaisApi/modals/Editar'
import ExcluirCredencial from 'templates/Integracoes/CredenciaisApi/modals/Excluir'
import RegenerarSegredoCredencial from 'templates/Integracoes/CredenciaisApi/modals/RegenerarSegredo'

const Afd = React.lazy(() => import('pages/Afd'))
const GerarAej = React.lazy(() => import('pages/GerarAej'))
const Reps = React.lazy(() => import('pages/Reps'))
const FolhaPagamento = React.lazy(() => import('pages/FolhaPagamento'))
const CredenciaisApi = React.lazy(() => import('pages/CredenciaisApi'))
const HistoricoExportacaoFolha = React.lazy(
    () => import('templates/Integracoes/FolhaPagamento/modal/Historico'),
)

const base = '/integracoes'

export const integracoes: RouteObject = {
    path: base,
    children: [
        {
            path: base + '/afd',
            element: <Afd />,
            children: [
                {
                    path: base + '/afd/importar',
                    element: <ImportarAFD />,
                },
                {
                    path: base + '/afd/exportar',
                    element: <GerarAfdModal />,
                },
            ],
        },
        {
            path: base + '/aej',
            element: <GerarAej />,
            children: [
                {
                    path: base + '/aej/relatorio',
                    element: <GerarRelatorioAEJ />,
                },
                {
                    path: base + '/aej/:id/excluir',
                    element: <ExcluirAEJ />,
                },
            ],
        },
        {
            path: base + '/importar-funcionarios',
            element: <Navigate to="/cadastros/funcionarios/importar" />,
        },
        {
            path: base + '/exportar-funcionarios',
            element: <Navigate to="/cadastros/funcionarios/exportar" />,
        },
        {
            path: base + '/importar-exportar-funcionarios',
            element: <Navigate to="/cadastros/funcionarios" />,
        },
        {
            path: base + '/reps',
            element: <Reps />,
            children: [
                {
                    path: base + '/reps/adicionar',
                    element: <AdicionarRep />,
                },
                {
                    path: base + '/reps/:id/excluir',
                    element: <ExcluirRep />,
                },
                {
                    path: base + '/reps/:id/editar',
                    element: <EditarRep />,
                },
                {
                    path: base + '/reps/:id/associar',
                    element: <AssociarFuncionariosRep />,
                },
            ],
        },
        {
            path: base + '/folha-pagamento',
            element: <FolhaPagamento />,
            children: [
                {
                    path: base + '/folha-pagamento/exportar-txt',
                    element: <ExportacaoTxt />,
                },
                {
                    path: base + '/folha-pagamento/historico',
                    element: <HistoricoExportacaoFolha />,
                    index: true,
                },
            ],
        },
        {
            path: base + '/credenciais-api',
            element: <CredenciaisApi />,
            children: [
                {
                    path: base + '/credenciais-api/adicionar',
                    element: <AdicionarCredencial />,
                },
                {
                    path: base + '/credenciais-api/:id/editar',
                    element: <EditarCredencial />,
                },
                {
                    path: base + '/credenciais-api/:id/regenerar',
                    element: <RegenerarSegredoCredencial />,
                },
                {
                    path: base + '/credenciais-api/:id/excluir',
                    element: <ExcluirCredencial />,
                },
            ],
        },
    ],
}
